<template>
  <div class="slds-form-element slds-form-element_stacked">
    <label class="slds-form-element__label" :for="htmlId"> {{ label }}</label>
    <div class="slds-form-element__control">
      <div class="slds-combobox_container">
        <div
          class="slds-combobox slds-dropdown-trigger slds-dropdown-trigger_click"
          :class="{ 'slds-is-open': inputSelected }"
          aria-haspopup="listbox"
          role="combobox"
        >
          <div
            class="slds-combobox__form-element slds-input-has-icon slds-input-has-icon_right"
            role="none"
          >
            <input
              type="text"
              class="slds-input slds-combobox__input"
              :id="htmlId"
              aria-controls="lookupDropdown"
              autocomplete="on"
              role="textbox"
              placeholder="Select..."
              @click="toggleSelected"
              :disabled="toDisable()"
            />
            <span
              class="slds-icon_container slds-icon-utility-search slds-input__icon slds-input__icon_right"
            >
              <svg
                class="slds-icon slds-icon slds-icon_x-small slds-icon-text-default"
                aria-hidden="true"
              >
                <use
                  xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#search"
                ></use>
              </svg>
            </span>
          </div>
          <div
            id="lookupDropdown"
            class="slds-dropdown slds-dropdown_fluid"
            role="listbox"
          >
            <ul class="slds-listbox slds-listbox_vertical" role="presentation">
              <li
                role="presentation"
                class="slds-listbox__item"
                v-for="option in options"
                :key="option.lookUpValueCode"
                @click="selectOption(option)"
              >
                <div
                  :id="option.lookUpValueCode"
                  class="slds-media slds-listbox__option slds-listbox__option_entity slds-listbox__option_has-meta"
                  role="option"
                >
                  <span class="slds-media__body">
                    <span
                      class="slds-listbox__option-text slds-listbox__option-text_entity"
                      >{{ option.lookUpValueText }}</span
                    >
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="slds-pill_container">
      <div class="slds-assistive-text" id="listbox-pill-with-icon">
        Press delete or backspace to remove
      </div>
      <ul
        class="slds-listbox slds-listbox_horizontal"
        role="listbox"
        aria-label="Selected Options:"
        aria-orientation="horizontal"
        aria-describedby="listbox-pill-with-icon"
      >
        <li
          class="slds-listbox-item"
          role="presentation"
          v-for="(column, index) in selectedColumns"
          :key="column.lookUpValueCode"
        >
          <span
            class="slds-pill"
            role="option"
            tabindex="0"
            aria-selected="true"
          >
            <span
              class="slds-pill__label"
              title="Full pill label verbiage mirrored here"
              >{{ column.lookUpValueText }}</span
            >
            <span
              class="slds-icon_container slds-pill__remove"
              title="Remove"
              @click="removeColumn(index, column)"
            >
              <svg
                class="slds-icon slds-icon_x-small slds-icon-text-default"
                aria-hidden="true"
              >
                <use
                  xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"
                ></use>
              </svg>
            </span>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "Lookup",
  props: {
    htmlId: String,
    options: Array,
    selectedColumns: Array,
    label: String,
    limit: { default: -1, type: Number },
  },
  data() {
    return {
      inputSelected: false,
      totalColumns: 0,
    };
  },
  created() {
    let reducer = (acc, curr) => acc + curr.lookUpValueCode.split(",").length;
    this.totalColumns = this.selectedColumns
      ? this.selectedColumns.reduce(reducer, 0)
      : 0;
  },
  methods: {
    toggleSelected: function() {
      this.inputSelected = !this.inputSelected;
    },
    selectOption: function(column) {
      //Only add item if it is not selected
      let item = this.selectedColumns.filter(
        (el) => el.lookUpValueCode == column.lookUpValueCode
      );
      if (!item.length) {
        this.selectedColumns.push(column);
        this.totalColumns += column.lookUpValueCode.split(",").length;
      }
      // Do not allow more than 3 column Grouping
      if (this.limit !== -1 && this.totalColumns > this.limit) {
        this.removeColumn(this.selectedColumns.length - 1, column);
      }
      this.toggleSelected();
      this.updateParent();
    },
    removeColumn: function(index, column) {
      this.selectedColumns.splice(index, 1);
      this.totalColumns -= column.lookUpValueCode.split(",").length;
      this.updateParent();
    },
    updateParent: function() {
      this.$emit("columnsSelected", this.selectedColumns);
    },
    toDisable: function() {
      return this.limit !== -1 && this.totalColumns >= this.limit;
    },
  },
};
</script>
